import { formatearDolares } from '@adelante/shared';

interface MontoDolaresProps {
  monto: number | null | undefined;
  className?: string;
}

/** Monto en dólares con formato es-CR (Flujo Semanal) — distinto de <MontoUSD> (en-US, Vencimientos). */
export function MontoDolares({ monto, className }: MontoDolaresProps) {
  if (monto === null || monto === undefined) return <span className={className}>—</span>;
  return <span className={className}>{formatearDolares(monto)}</span>;
}
